

















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ProductTab, Product, ProductTabTypeChange } from '@/models/Product';
import ProductInfoTab from './TabContent/ProductInfoTab.vue';
import DocumentTab from './TabContent/DocumentTab.vue';
import SpecificationTab from './TabContent/SpecificationTab.vue';
import Specification2Tab from './TabContent/Specification2Tab.vue';
import VariantsTab from './TabContent/VariantsTab.vue';
import Variants2Tab from './TabContent/Variants2Tab.vue';
import SimilarProductsTab from './TabContent/SimilarProductsTab.vue';
import BathroomColorsTab from './TabContent/BathroomColorsTab.vue';
import RelatedVariantsTab from './TabContent/RelatedVariantsTab.vue';
import { ProductTabStore } from '@/store/producttabstate';

@Component({
    components: {
        ProductInfoTab,
        DocumentTab,
        SpecificationTab,
        Specification2Tab,
        VariantsTab,
        Variants2Tab,
        SimilarProductsTab,
        BathroomColorsTab,
        RelatedVariantsTab
    }
})
export default class TabsLandscape extends Vue {
    @Prop()
    protected productTabs!: ProductTab[];
    @Prop()
    protected productItemNumber!: string;

    constructor() {
        super();
    }

    protected setSelected(selectedTab: ProductTab) {
        this.productTabs.forEach(element => {
            element.Selected = false;
        });

        selectedTab.Selected = true;
    }

    @Watch('getSelectedTabType')
    private stateSelectedTabType() {
        const tab = this.getSelectedTabType;
        if (tab != null) {
            this.productTabs.forEach(element => {
                element.Selected = false;
                if (element.TabType == tab.TabType) {
                    element.Selected = true;
                    if (tab.Scroll) {
                        this.scrollTo('tabs-landscape');
                    }
                }
            });
        }
    }

    get getSelectedTabType(): ProductTabTypeChange {
        return ProductTabStore.getSelectedTabTypeLandscape;
    }

    private scrollTo(id: any) {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }
    }
}
